import { createAction } from 'store/utils';
import { TaxRate } from 'store/returns/models/returnData';
import {
  DELETE_TAX_RATE_TEMPLATE_FAILURE,
  DELETE_TAX_RATE_TEMPLATE_REQUEST,
  DELETE_TAX_RATE_TEMPLATE_SUCCESS,
  DELETE_EXCEL_TAX_RATE_FAILURE,
  DELETE_EXCEL_TAX_RATE_REQUEST,
  DELETE_EXCEL_TAX_RATE_SUCCESS,
  UPDATE_EXCEL_TAX_RATE_NAME_FAILURE,
  UPDATE_EXCEL_TAX_RATE_NAME_REQUEST,
  UPDATE_EXCEL_TAX_RATE_NAME_SUCCESS,
  CREATE_EXCEL_TAX_RATE_FAILURE,
  CREATE_EXCEL_TAX_RATE_REQUEST,
  CREATE_EXCEL_TAX_RATE_SUCCESS,
  EDIT_TAX_RATE_TEMPLATE_NAME_FAILURE,
  EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST,
  EDIT_TAX_RATE_TEMPLATE_NAME_SUCCESS,
  FETCH_TAX_RATES_BY_COUNTRY_FAILURE,
  FETCH_TAX_RATES_BY_COUNTRY_REQUEST,
  FETCH_TAX_RATES_BY_COUNTRY_SUCCESS,
  GET_TAX_RATE_TEMPLATES_FAILURE,
  GET_TAX_RATE_TEMPLATES_REQUEST,
  GET_TAX_RATE_TEMPLATES_SUCCESS,
  SAVE_TAX_RATE_TEMPLATE_FAILURE,
  SAVE_TAX_RATE_TEMPLATE_REQUEST,
  SAVE_TAX_RATE_TEMPLATE_SUCCESS,
  SAVE_TAX_RATES_FAILURE,
  SAVE_TAX_RATES_REQUEST,
  SAVE_TAX_RATES_SUCCESS,
  SET_GETTING_TAXES,
  REFRESH_CONNECTION_TAX_RATES_REQUEST,
} from './constants';
import {
  TaxRateTemplate,
  TaxRateTemplateToSave,
} from './models';
import { ExcelTaxRateRequest } from './api';

// Getting Taxes flag
export const setGettingTaxes = (gettingTaxes: boolean) =>
  createAction(SET_GETTING_TAXES, {
    gettingTaxes,
  });

// Save Tax Rate Template
export const saveTaxRateTemplateRequest = (
  connectionId: string,
  taxRateTemplate: TaxRateTemplateToSave
) =>
  createAction(SAVE_TAX_RATE_TEMPLATE_REQUEST, {
    connectionId,
    taxRateTemplate,
  });

export const saveTaxRateTemplateSuccess = () =>
  createAction(SAVE_TAX_RATE_TEMPLATE_SUCCESS);

export const saveTaxRateTemplateFailure = () =>
  createAction(SAVE_TAX_RATE_TEMPLATE_FAILURE);

// Get Tax Rate Templates
export const getTaxRateTemplatesRequest = () =>
  createAction(GET_TAX_RATE_TEMPLATES_REQUEST);

export const getTaxRateTemplatesSuccess = (templates: TaxRateTemplate[]) =>
  createAction(GET_TAX_RATE_TEMPLATES_SUCCESS, { templates });

export const getTaxRateTemplatesFailure = () =>
  createAction(GET_TAX_RATE_TEMPLATES_FAILURE);

// Delete Tax Rate Template
export const deleteTaxRateTemplateRequest = (templateId: string) =>
  createAction(DELETE_TAX_RATE_TEMPLATE_REQUEST, { templateId });

export const deleteTaxRateTemplateSuccess = () =>
  createAction(DELETE_TAX_RATE_TEMPLATE_SUCCESS);

export const deleteTaxRateTemplateFailure = () =>
  createAction(DELETE_TAX_RATE_TEMPLATE_FAILURE);

// Delete Excel Tax Rate (for Excel / Receipts entities)
export const deleteExcelTaxRateRequest = (
  connectionId: string,
  taxRateId: string
) =>
  createAction(DELETE_EXCEL_TAX_RATE_REQUEST, {
    connectionId,
    taxRateId,
  });

export const deleteExcelTaxRateSuccess = () =>
  createAction(DELETE_EXCEL_TAX_RATE_SUCCESS);

export const deleteExcelTaxRateFailure = () =>
  createAction(DELETE_EXCEL_TAX_RATE_FAILURE);

// Update Excel Tax Rate Name
export const updateExcelTaxRateNameRequest = (
  connectionId: string,
  taxRateId: string,
  taxName: string,
  taxType: string
) =>
  createAction(UPDATE_EXCEL_TAX_RATE_NAME_REQUEST, {
    connectionId,
    taxRateId,
    taxName,
    taxType,
  });

export const updateExcelTaxRateNameSuccess = () =>
  createAction(UPDATE_EXCEL_TAX_RATE_NAME_SUCCESS);

export const updateExcelTaxRateNameFailure = (taxType: string) =>
  createAction(UPDATE_EXCEL_TAX_RATE_NAME_FAILURE, { taxType });

// Create Excel Tax Rate (for Excel / Receipts entities)
export const createExcelTaxRateRequest = (
  connectionId: string,
  excelTaxRate: ExcelTaxRateRequest
) =>
  createAction(CREATE_EXCEL_TAX_RATE_REQUEST, {
    connectionId,
    excelTaxRate,
  });

export const createExcelTaxRateSuccess = () =>
  createAction(CREATE_EXCEL_TAX_RATE_SUCCESS);

export const createExcelTaxRateFailure = () =>
  createAction(CREATE_EXCEL_TAX_RATE_FAILURE);

// Edit Tax Rate Template Name
export const editTaxRateTemplateNameRequest = (
  templateId: string,
  name: string
) =>
  createAction(EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST, {
    templateId,
    name,
  });

export const editTaxRateTemplateNameSuccess = () =>
  createAction(EDIT_TAX_RATE_TEMPLATE_NAME_SUCCESS);

export const editTaxRateTemplateNameFailure = () =>
  createAction(EDIT_TAX_RATE_TEMPLATE_NAME_FAILURE);

// Fetch Tax Rates by Country
export const fetchTaxRatesByCountryRequest = (countryId: string) =>
  createAction(FETCH_TAX_RATES_BY_COUNTRY_REQUEST, { countryId });

export const fetchTaxRatesByCountrySuccess = (
  taxRates: TaxRate[],
  countryId: string
) =>
  createAction(FETCH_TAX_RATES_BY_COUNTRY_SUCCESS, {
    taxRates,
    countryId,
  });

export const fetchTaxRatesByCountryFailure = () =>
  createAction(FETCH_TAX_RATES_BY_COUNTRY_FAILURE);

// Save Tax Rates for an entity/connection
export const saveTaxRatesRequest = (
  connectionId: string,
  rates: string[]
) =>
  createAction(SAVE_TAX_RATES_REQUEST, {
    connectionId,
    rates,
  });

export const saveTaxRatesSuccess = (
  taxRates: TaxRate[],
  connectionId: string
) =>
  createAction(SAVE_TAX_RATES_SUCCESS, {
    taxRates,
    connectionId,
  });

export const saveTaxRatesFailure = () =>
  createAction(SAVE_TAX_RATES_FAILURE);

// Refresh tax rates for a single connection (helper used after uploads, etc.)
export const refreshConnectionTaxRatesRequest = (
  connectionId: string,
  suppressMessages: boolean = false
) =>
  createAction(REFRESH_CONNECTION_TAX_RATES_REQUEST, {
    connectionId,
    suppressMessages,
  });

